import React from 'react';

import { W2_TID } from '../constants/testids';
import type { W2LinkStatus } from '../api/w2';
import { W2Shell } from './W2Shell';

interface W2LinkErrorProps {
  /** null → unknown/invalid token; otherwise the non-Active link status. */
  status: W2LinkStatus | null;
}

function messageFor(status: W2LinkStatus | null): {
  title: string;
  body: string;
} {
  switch (status) {
    case 'Disabled':
      return {
        title: 'This link is not active',
        body: 'Your employer’s enrollment link is currently disabled. Please contact your employer or benefits administrator.',
      };
    case 'Archived':
      return {
        title: 'This link is no longer available',
        body: 'Your employer’s enrollment link has been archived. Please contact your employer or benefits administrator.',
      };
    default:
      return {
        title: 'This link is invalid',
        body: 'We couldn’t find an enrollment matching this link. Please double-check the link from your employer.',
      };
  }
}

/** Branded error page for Disabled / Archived / invalid tokens — no flow renders. */
export const W2LinkError: React.FC<W2LinkErrorProps> = ({ status }) => {
  const { title, body } = messageFor(status);
  return (
    <W2Shell>
      <div data-testid={W2_TID.linkError.root} className="flex flex-col gap-4">
        <h1
          data-testid={W2_TID.linkError.title}
          className="text-3xl font-extrabold text-[#1a1a2e] max-sm:text-2xl"
        >
          {title}
        </h1>
        <p className="text-[15px] leading-6 text-[#5a5a70]">{body}</p>
      </div>
    </W2Shell>
  );
};
